import { useEffect, useState } from "react";

/** Hash routes keep the app a single static bundle the API can serve: #/signin, #/onboarding/kyc?session=… */
export interface Route {
  path: string;
  query: URLSearchParams;
}

function read(): Route {
  const raw = window.location.hash.replace(/^#/, "") || "/";
  const [path = "/", qs = ""] = raw.split("?");
  return { path, query: new URLSearchParams(qs) };
}

export function useRoute(): Route {
  const [route, setRoute] = useState(read);
  useEffect(() => {
    const on = () => setRoute(read());
    window.addEventListener("hashchange", on);
    return () => window.removeEventListener("hashchange", on);
  }, []);
  return route;
}

export function go(path: string): void {
  if (window.location.hash !== `#${path}`) window.location.hash = path;
}
